<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!--
                <h1>Voucher Info</h1>
                <p>{{ this.voucher_uuid }}</p>
                <p>{{ this.voucher_denomination }}</p>
                <p>{{ this.product_name }}</p>
                <p>{{ this.product_description }}</p>
                <p>
                    <img v-bind:src="'https://www.gifted.ph/uploads/images/medium/' + this.product_images" alt="asd">
                </p>
                <p>{{ this.order_number }}</p>
                <p>{{ this.recipient_lastname }}</p>
                <p>{{ this.recipient_firstname }}</p>
                <p>{{ this.date_issued }}</p>
                -->


                <div class="col-12 mt-4 mb-4 gifted-voucher">
                    <div class="card border-0">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                <div class="col-md-6">

                                </div>
                            </div>
                        </div>
                        <div class="card card-title">
                            <h3>
                                You've been Gifted!<br/>
                                This voucher entitles you to purchase the following at:
                            </h3>

                        </div>
                        <div class="row">
                            <div class="col-md-5 brand-logo-wrapper">
                                <img class="m-2" v-bind:src="'https://portal.gifted.ph/storage/images/medium/' + this.product_logo" v-bind:alt="this.product_name"  v-bind:title="this.product_name" />

                            </div>
                            <div class="col-md-7 voucher-details-wrapper">
                                <div class="card no-border">
                                    <div class="card-header voucher-code">
                                        <!-- <img v-bind:src="this.barcode" alt="" v-if="this.barcode" class="img-responsive" /> -->
                                        <div v-if="this.barcode" v-html="this.barcode"></div>
                                        <h4 v-if="this.voucher_code && !this.barcode">{{ this.voucher_code }}</h4>

                                       <h4 v-if="this.voucher_barcode.first">{{ this.voucher_barcode.first }}</h4>
                                       <h4 v-if="this.voucher_barcode.second">{{ this.voucher_barcode.second }}</h4>
                                       <h4 v-if="this.voucher_barcode.third">{{ this.voucher_barcode.third }}</h4>

                                       <p>Voucher Code or Bcode</p>
                                    </div>
                                    <ul class="list-group list-group-flush">
                                        <li  v-if="this.clean_voucher" class="list-group-item">Voucher Code or Bcode: <b>{{ this.clean_voucher }}</b></li>
                                        <li  v-if="!this.is_product" class="list-group-item">Amount: <b>&#8369; {{ this.voucher_denomination }}</b></li>
                                        <li class="list-group-item">Order #: <b>{{ this.order_number }}</b></li>
                                        <li class="list-group-item">Surname: <b>{{ this.recipient_lastname }}</b></li>
                                        <li class="list-group-item">Date Issued: <b>{{ this.date_issued }}</b></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div class="row" style="margin: 10px;">
                            <div class="col-md-12 product-description" v-html="this.product_description">
                                {{ this.product_description }}
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a> or email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>
    .gifted-voucher{
        max-width: 900px;
        margin: 0 auto;
    }
    .gifted-voucher .card-header{
        background-color: #fff;
    }
    .gifted-voucher .card-title{
        background-color: #D14955;
        border-radius: 0;
        padding: 20px;
    }
    .gifted-voucher .card-title h3{
        color: #fff;
        margin: 0;
        font-size: 20px;
        line-height: 22px;
    }
    .gifted-voucher .brand-logo-wrapper{

    }
    .gifted-voucher .brand-logo-wrapper img{
        width: 100%;
    }
    .gifted-voucher .voucher-details-wrapper{

    }
    .gifted-voucher .product-description{

    }
    .gifted-voucher .product-description p strong{
        font-size: 16px;
        clear: both;
        display: block;
        line-height: 20px;
    }
    .gifted-voucher .voucher-details-wrapper{

    }
    .gifted-voucher .voucher-details-wrapper b{
        font-size: 16px;
    }
    .gifted-voucher .voucher-details-wrapper .voucher-code{
        background-color: #fff;
        border: 0px;
    }
    .gifted-voucher .voucher-details-wrapper .no-border{
        border-left: none;
        border-right: none;
    }

    .gifted-voucher .voucher-details-wrapper  .voucher-code h4{
        margin: 0;
        text-align: center;
    }
    .gifted-voucher .voucher-details-wrapper  .voucher-code p{
        margin: 0;
        text-align: center;
        font-size: 12px;
        line-height: 14px;
    }
    .gifted-voucher .card-footer{
        padding: 20px;
        background-color: #D14955;
    }
    .gifted-voucher .card-footer h2{
        display: block;
        margin: 0;
        color: #fff;
        font-size: 16px;
        line-height: 18px;
        font-weight: bold;
    }
    .gifted-voucher .card-footer p{
        display: block;
        margin: 0;
        color: #fff;
    }
    .gifted-voucher .card-footer p:last-child{

    }
    .gifted-voucher .card-footer p a{
        font-weight: bold;
        text-decoration: underline;
        color: #fff;
    }
</style>
<script>
    export default {
        props: ['details'],
        data(){
            return {
                voucher_uuid: "",
                voucher_code: "",
                clean_voucher: "",
                voucher_denomination: "",
                product_name: "",
                is_product: "",
                product_description: "",
                product_logo: "",
                order_number: "",
                recipient_lastname: "",
                recipient_firstname: "",
                date_issued: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {
            // Swal.fire({
            //     title: 'Voucher PIN',
            //     input: 'text',
            //     inputAttributes: {
            //         autocapitalize: 'off'
            //     },
            //     showCancelButton: true,
            //     confirmButtonText: 'Validate',
            //     showLoaderOnConfirm: true,
            //     preConfirm: (login) => {
            //         return fetch(`//api.github.com/users/${login}`)
            //         .then(response => {
            //             if (!response.ok) {
            //             throw new Error(response.statusText)
            //             }
            //             return response.json()
            //         })
            //         .catch(error => {
            //             Swal.showValidationMessage(
            //             `Request failed: ${error}`
            //             )
            //         })
            //     },
            //     //allowOutsideClick: false,
            //     showCancelButton: false
            // }).then((result) => {
            //     if (result.isConfirmed) {
            //         Swal.fire({
            //         title: `${result.value.login}'s avatar`,
            //         imageUrl: result.value.avatar_url
            //         })
            //     }
            // })
            const voucher = JSON.parse(this.details)
            this.voucher_uuid = voucher.voucher_uuid;
            this.voucher_code = voucher.voucher_code;
            this.clean_voucher = voucher.clean_voucher;
            this.voucher_barcode = JSON.parse(voucher.voucher_barcode);
            this.barcode = voucher.barcode;
            this.voucher_denomination = voucher.voucher_denomination;
            this.product_name = voucher.product_name;
            this.is_product = voucher.is_product;
            this.product_description = voucher.product_description;
            this.product_logo = voucher.product_logo;

            this.order_number = voucher.order_number;
            this.recipient_lastname = voucher.recipient_lastname;
            this.recipient_firstname = voucher.recipient_firstname;
            this.date_issued = voucher.date_issued;
            t
        }
    }



</script>
